const UrlApi = {
  baseUrl: process.env.REACT_APP_BASEURL,
  baseUrlImage: process.env.REACT_APP_BASEURLIMAGE,
  baseUrlclient: process.env.REACT_APP_BASEURL_CLIENT,
  baseUrlImageClient: process.env.REACT_APP_BASEURLIMAGE,
  auth: {
    login: "auth/login",
    autologin: "auth/autologin",
    logout: "auth/logout",
    forgotPassword: "auth/forgot-password",
    resetPassword: "auth/reset-password",
  },
  admins: {
    get: "admins/get",
    add: "admins/add",
    edit: "admins/edit",
    delete: "admins/delete",
    getUserType: "admins/get_user_type",
    getUserPrivilegs: "admins/privileg",
    addUserPrivilegs: "admins/addprivileg",
    editUserPrivilegs: "admins/editprivileg",
    deleteprivileg: "admins/deleteprivileg",
  },
  doctors: {
    get: "doctors/get",
    add: "doctors/add",
    edit: "doctors/edit",
    delete: "doctors/delete",
  },
  roles: { get: "roles/get", add: "roles/add", edit: "roles/edit", delete: "roles/delete" },
  rooms: { get: "rooms/get", add: "rooms/add", edit: "rooms/edit", delete: "rooms/delete" },
  services: { get: "services/get", add: "services/add", edit: "services/edit", delete: "services/delete" },
  service_pricelist: { get: "service_pricelist/get", add: "service_pricelist/add", edit: "service_pricelist/edit", delete: "service_pricelist/delete" },
  client_categories: { get: "client_categories/get", add: "client_categories/add", edit: "client_categories/edit", delete: "client_categories/delete" },
  referrals: {
    stats: "clients/referrals/stats",
  },
  clients: {
    get: "clients/get",
    formOptions: "clients/form-options",
    outsideDoctorsAdd: "clients/outside-doctors/add",
    add: "clients/add",
    import: "clients/import",
    edit: "clients/edit",
    delete: "clients/delete",
  },
  medical_history: { get: "medical_history/get", add: "medical_history/add", edit: "medical_history/edit", delete: "medical_history/delete" },
  plan_categories: { get: "plan_categories/get", add: "plan_categories/add", edit: "plan_categories/edit", delete: "plan_categories/delete" },
  treatment_plans: {
    get: "treatment_plans/get",
    formOptions: "treatment_plans/form-options",
    add: "treatment_plans/add",
    edit: "treatment_plans/edit",
    delete: "treatment_plans/delete",
    copy: "treatment_plans/copy",
  },
  appointments: {
    get: "appointments/get",
    formOptions: "appointments/form-options",
    add: "appointments/add",
    edit: "appointments/edit",
    delete: "appointments/delete",
    calculatePrice: "appointments/calculate-price",
    completePast: "appointments/complete-past",
    skippedPending: "appointments/skipped-pending",
    skippedDismiss: "appointments/skipped-dismiss",
  },
  calendar: {
    get: "calendar/get",
    holidayAdd: "calendar/holidays/add",
    holidayEdit: "calendar/holidays/edit",
    holidayDelete: "calendar/holidays/delete",
    blockedAdd: "calendar/blocked-time/add",
    blockedEdit: "calendar/blocked-time/edit",
    blockedDelete: "calendar/blocked-time/delete",
  },
  invoices: {
    get: "invoices/get",
    details: "invoices/details",
    formOptions: "invoices/form-options",
    uninvoicedAppointments: "invoices/uninvoiced-appointments",
    add: "invoices/add",
    edit: "invoices/edit",
    delete: "invoices/delete",
  },
  receipts: {
    get: "receipts/get",
    formOptions: "receipts/form-options",
    printData: "receipts/print-data",
    add: "receipts/add",
    edit: "receipts/edit",
    delete: "receipts/delete",
  },
  client_accounts: { get: "client_accounts/get", add: "client_accounts/add", edit: "client_accounts/edit", delete: "client_accounts/delete" },
  expenses_types: { get: "expenses_types/get", add: "expenses_types/add", edit: "expenses_types/edit", delete: "expenses_types/delete" },
  expenses_list: {
    get: "expenses_list/get",
    formOptions: "expenses_list/form-options",
    add: "expenses_list/add",
    edit: "expenses_list/edit",
    delete: "expenses_list/delete",
  },
  payment_vouchers: {
    get: "payment_vouchers/get",
    formOptions: "payment_vouchers/form-options",
    add: "payment_vouchers/add",
    edit: "payment_vouchers/edit",
    delete: "payment_vouchers/delete",
  },
  expenses_accounts: {
    get: "expenses_accounts/get",
    formOptions: "expenses_accounts/form-options",
    add: "expenses_accounts/add",
    edit: "expenses_accounts/edit",
    delete: "expenses_accounts/delete",
  },
  fixed_income: {
    get: "fixed_income/get",
    add: "fixed_income/add",
    edit: "fixed_income/edit",
    delete: "fixed_income/delete",
    paymentsGet: "fixed_income/payments/get",
    paymentsAdd: "fixed_income/payments/add",
    paymentsEdit: "fixed_income/payments/edit",
    paymentsDelete: "fixed_income/payments/delete",
  },
  dashboard: {
    summary: "dashboard/summary",
  },
  admin_logs: { get: "admin_logs/get", edit: "admin_logs/edit" },
  settings: {
    get: "settings/get",
    edit: "settings/edit",
  },
  reOrder: "re-order",
};

export default UrlApi;
